import { ReactNode, createContext, useContext, useState } from "react";
import ApproveModal from "./ApproveModal";
import { IReportRequest } from "models/reportRequest";
import RejectModal from "./RejectModal";

interface IAlertProps {
  showReject: (account: IReportRequest) => void;
  showApprove: (account: IReportRequest) => void;
}

export const AlertContext = createContext<IAlertProps>({} as IAlertProps);

export const useAlertContext = () => useContext<IAlertProps>(AlertContext);

interface IOpen {
  open: boolean;
  reportRequest: IReportRequest | null;
}

export function AlertContextProvider({ children }: { children: ReactNode }) {
  const [openReject, setOpenReject] = useState<IOpen>({
    open: false,
    reportRequest: null,
  });
  const [openApprove, setOpenApprove] = useState<IOpen>({
    open: false,
    reportRequest: null,
  });

  const showReject = (reportRequest: IReportRequest) =>
    setOpenReject({ open: true, reportRequest });
  const showApprove = (reportRequest: IReportRequest) =>
    setOpenApprove({ open: true, reportRequest });

  const handleCloseReject = () =>
    setOpenReject({ open: false, reportRequest: null });
  const handleCloseApprove = () =>
    setOpenApprove({ open: false, reportRequest: null });

  return (
    <AlertContext.Provider
      value={{
        showApprove,
        showReject,
      }}
    >
      {openReject.reportRequest && (
        <RejectModal
          open={openReject.open}
          reportRequest={openReject.reportRequest}
          handleClose={handleCloseReject}
        />
      )}

      {openApprove.reportRequest && (
        <ApproveModal
          open={openApprove.open}
          reportRequest={openApprove.reportRequest}
          handleClose={handleCloseApprove}
        />
      )}
      {children}
    </AlertContext.Provider>
  );
}
